
<div>
  <page-header>
    <div class="text-nowrap text-dark ml-4 mr-3">
      <h4 class="form-check-label">
        {{ so.name }}
      </h4>
      <small class="font-weight-bold">{{so.type}}</small>
    </div>

    <router-link v-if="store.currentOccurrence.isCompleted" class="ml-1" :to="{ name: 'so-overview' }">
      <div class="badgebutton active text-nowrap c-white ml-2">
        <i class="far fa-caret-left"></i>
        Back to Special Occurrence overview
      </div>
    </router-link>

    <router-link v-if="!store.currentOccurrence.isCompleted" class="ml-1" :to="{ name: 'Boards' }">
      <div class="badgebutton active text-nowrap c-white ml-2">
        <i class="far fa-caret-left"></i>
        Back to landing page
      </div>
    </router-link>
  </page-header>

  <SpecialOccurrence />
</div>
